import { api } from "./api.service";

export interface CreateAppointmentPayload {
  scheduleId: string;
  patientId: string;
  startTime?: string; // ISO
  slotMinutes?: number;
}

export async function createAppointmentFromSchedule(payload: CreateAppointmentPayload) {
  const { data } = await api.post("/appointments/from-schedule", payload);
  return data;
}

export interface RescheduleAppointmentPayload {
  appointmentId: string;
  newStartTime: string; // ISO
}

export async function rescheduleAppointment(payload: RescheduleAppointmentPayload) {
  const { data } = await api.post("/appointments/reschedule", payload);
  return data;
}

export interface ConfirmPresencePayload {
  appointmentId: string;
  pin: string;
  presenceStatus: 'PRESENTE' | 'AUSENTE';
}

export async function confirmAppointmentPresence(payload: ConfirmPresencePayload) {
  const { appointmentId, ...body } = payload;
  const { data } = await api.post(`/appointments/${appointmentId}/confirm-presence`, body);
  return data;
}
